import { Component, OnInit,  NgZone, Inject, EventEmitter } from '@angular/core';
import { AuthService } from 'shared/auth/auth.service';
import { BrandService } from 'shared/brand/brand.service';
import { UploadOutput, UploadInput } from 'shared/ngx-uploader/classes/ngx-uploader.class';
import { Subscription } from 'rxjs';
import { Config } from 'shared/config/env.config';
import { MyProductsStoreDataService } from 'shared/my-products-store-data/my-products-store-data.service';
import { BrandInfoService } from 'shared/brand/brand-info.service';


@Component({
    moduleId: module.id,
    selector: 'file-uploader',
    templateUrl: 'file-uploader.component.html'
})

export class FileUploaderComponent implements OnInit {
  subscription: Subscription;
  uploadSubscription: Subscription;
  response: any;
  sizeLimit: number = 1000000; // 1MB
  previewData: any;
  errorMessage: string;
  uploadInput: EventEmitter<UploadInput>;
  brandName: string = '';

  public percentageComplete: number = 25;
  public selectedBrand: string;
  public selectedType: number = 1;
  public types: any[] = [
      {id: 'PIES', type: 'PIES'},
      {id: 'ACES', type: 'ACES'},
      // {id: 'ASSETS', type: 'ASSETS'}
  ];

  constructor(
      @Inject(NgZone) private zone: NgZone,
      private brandService: BrandService,
      private brandInfoService: BrandInfoService,
      private authService: AuthService,
      private myProductsStoreDataService: MyProductsStoreDataService
  ) {  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    this.selectedBrand = this.brandService.getBrand();
    this.uploadInput = new EventEmitter<UploadInput>();
    this.refreshBrandName();
  }


  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  startUpload() {
    console.log('fire', Config.API, this.selectedBrand);
    const event: UploadInput = {
      type: 'uploadAll',
      url: `${Config.API}/imports-upload/${this.selectedBrand}`,
      method: 'POST',
      data: {type: `${this.selectedType}`},
      headers: {
        'Authorization': `Bearer ${this.authService.token()}`,
      },
      withCredentials: false,
    };
    console.log('fire?');
    this.uploadInput.emit(event);
  }

  activateMenu(menu: string) {
    this.myProductsStoreDataService.setMenuItemVisibility(menu, true);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onUploadOutput(output: UploadOutput) {
    if (output.file && output.file.progress.data) {
      this.percentageComplete = output.file.progress.data.percentage;
      this.response = output.file.progress.data;
    }
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private refreshBrandName() {
    this.brandInfoService.fetch(this.brandService.getBrand())
    .subscribe((brandData: any) => {
      if (brandData) {
        this.brandName = brandData.company_name;
      }
    });
  }
}
